module.exports = __webpack_public_path__ + "static/media/cluster.94160cb9.svg";